/* SUNKIS Science page (from sunkis-main-pdp assets/js/science.js): hero orbit. Outer arc portraits travel right, inner arc travel left. */
(function () {
  var orbit = document.querySelector('.sx-orbit');
  if (!orbit) return;

  /* geometry in a 829 x 500 box, everything expressed in % so it scales fluidly */
  var W = 829, R_OUT = 414, R_IN = 244, CX = W / 2, CY = 456;
  var H = 500;
  var rings = [
    { sel: '.sx-ring--out img', r: R_OUT, domain: 190, speed: 7, dir: 1,  base: [14, 51, 90, 129, 166] },
    { sel: '.sx-ring--in img',  r: R_IN,  domain: 176, speed: 5, dir: -1, base: [46, 134] }
  ];
  rings.forEach(function (g) { g.els = Array.prototype.slice.call(orbit.querySelectorAll(g.sel)); });

  var FADE = 11;
  function ease(x) { x = Math.max(0, Math.min(1, x)); return x * x * (3 - 2 * x); }

  function place(g, t) {
    g.els.forEach(function (el, i) {
      var p = ((g.base[i] + g.dir * g.speed * t) % g.domain + g.domain) % g.domain;
      var theta = (180 - p) * Math.PI / 180;
      var x = CX + g.r * Math.cos(theta), y = CY - g.r * Math.sin(theta);
      var o = p > 180 ? 0 : Math.min(ease(p / FADE), ease((180 - p) / FADE));
      el.style.left = (x / W * 100) + '%';
      el.style.top = (y / H * 100) + '%';
      el.style.opacity = o.toFixed(3);
    });
  }
  function frame(t) { rings.forEach(function (g) { place(g, t); }); }

  frame(0);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var raf = 0, start = 0, offset = 0, running = false;
  function tick(now) {
    if (!start) start = now;
    frame(offset + (now - start) / 1000);
    raf = requestAnimationFrame(tick);
  }
  function play() { if (running) return; running = true; start = 0; raf = requestAnimationFrame(tick); }
  function pause(now) {
    if (!running) return; running = false; cancelAnimationFrame(raf);
    if (start) offset += (performance.now() - start) / 1000;
  }
  new IntersectionObserver(function (es) { es[0].isIntersecting ? play() : pause(); }, { threshold: 0.05 }).observe(orbit);
  document.addEventListener('visibilitychange', function () { document.hidden ? pause() : play(); });
})();

/* Hero stays pinned and fades out while the next section slides over it (desktop only). */
(function () {
  var hero = document.querySelector('.sx-stack .sx-hero'), s2 = document.querySelector('.sx-s2');
  if (!hero || !s2) return;
  var wide = window.matchMedia('(min-width:1181px), (max-width:760px)'), reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function paint() {
    if (!wide.matches || reduce.matches) { hero.style.opacity = ''; return; }
    var vh = window.innerHeight, top = s2.getBoundingClientRect().top;
    var span = window.innerWidth <= 760 ? 0.66 : 0.78;
    var p = (top - vh * 0.12) / (vh * span);           /* 1 = section below the fold, 0 = fully covering */
    hero.style.opacity = Math.max(0, Math.min(1, p)).toFixed(3);
  }
  window.addEventListener('scroll', paint, { passive: true });
  window.addEventListener('resize', paint);
  paint();
})();

/* Load and play the phone video only on phones, and only while it is on screen. */
(function () {
  var v = document.querySelector('.sx-s2-vid');
  if (!v) return;
  var phone = window.matchMedia('(max-width:760px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var started = false;
  function start() {
    if (started || !phone.matches) return;
    started = true;
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
    v.preload = 'auto';
    v.src = v.getAttribute('data-src');
    v.load();
    if (reduce.matches) return;
    new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
    }, { threshold: 0.1 }).observe(v);
  }
  start();
  if (phone.addEventListener) phone.addEventListener('change', start);
  else if (phone.addListener) phone.addListener(start);
  window.addEventListener('resize', start);
})();
